// pages/signup-app/src/steps/checkout/InputComponentWrapper.tsx
import React from 'react'

type StripeChangeEvent = {
  complete?: boolean
  empty?: boolean
  error?: { message?: string }
}

type Props = {
  component: React.ElementType
  inputRef?: React.Ref<any> // MUI v4 passes inputRef to inputComponent
  name?: string
  onChange?: (event: any) => void
  onBlur?: (event: any) => void
  onFocus?: (event: any) => void
}

const InputComponentWrapper = React.forwardRef<any, Props>(function InputComponentWrapper (
    props,
    ref
) {
    const { component: Component, inputRef, name, onChange, onBlur, onFocus, ...other } = props

    // MUI expects an object with focus() (and sometimes a value)
    const muiHandleRef = React.useRef<{ focus:() => void; value?: string }>({
        focus: () => {
            // Stripe Elements focus is not guaranteed via ref in react-stripe-elements
            // (still satisfies MUI’s expected interface)
        },
        value: ''
    })

    React.useImperativeHandle(ref, () => muiHandleRef.current)
    React.useImperativeHandle(inputRef as any, () => muiHandleRef.current)

    const makeMuiEvent = (value: string) => ({
        target: { name, value }
    })

    return (
        <Component
            {...other}
            onChange={(e: StripeChangeEvent) => {
                // Stripe won't give card value (PCI), so give MUI a stable "value"
                const value = e?.complete ? 'complete' : ''
                muiHandleRef.current.value = value
                onChange?.(makeMuiEvent(value))
            }}
            onBlur={() => onBlur?.(makeMuiEvent(muiHandleRef.current.value || ''))}
            onFocus={() => onFocus?.(makeMuiEvent(muiHandleRef.current.value || ''))}
        />
    )
})

export default InputComponentWrapper
